// extracted by mini-css-extract-plugin
module.exports = {"authorName":"styles_authorName__i_otG","publishDate":"styles_publishDate__Nu8XJ"};